<template>
  <div class="table-container">
    <div class="d-flex justify-content-end manual-notes-filter-toggle">
      <b-button
        v-b-toggle:manual-notes-filter
        :class="`filter-button-group btn--smaller btn--transparent align-items-center gap-3${
          countActiveFilters ? ' active' : ''
        }`"
        variant="-transparent"
        size="sm"
        title="Apri i filtri"
      >
        <base-icon name="filters" width="23" height="23" />
        <span>
          Ricerca con filtri{{
            countActiveFilters ? ` (${countActiveFilters})` : ""
          }}
        </span>
      </b-button>
    </div>
    <b-collapse id="manual-notes-filter">
      <b-form @submit.prevent="onSearch(filterName)">
        <b-card class="filter">
          <b-row>
            <div class="col-md-4">
              <base-input
                name="number"
                type="text"
                label="Numero polizza"
                autocomplete="off"
                v-model="filter.byInsurancePolicy.number"
                placeholder="Inserisci un numero polizza"
              />
            </div>
            <div class="col-md-4">
              <b-button-toolbar class="manual-notes-registry-picker">
                <b-button-group>
                  <base-input
                    name="Anagrafica"
                    label="Contraente"
                    autocomplete="off"
                    v-model="form.inpt_label_registry"
                    :readonly="true"
                  />
                  <b-button
                    class="btn-quick btn--light"
                    size="sm"
                    text="Button"
                    variant="lisaweb"
                    title="Cerca anagrafica"
                    @click="openQuickSearchRegistry"
                  >
                    <base-icon name="search" width="14" height="14"></base-icon>
                  </b-button>
                  <b-button
                    v-if="form.inpt_label_registry"
                    class="btn--light btn--alert"
                    size="sm"
                    text="Button"
                    variant="lisaweb"
                    title="Elimina anagrafica"
                    @click="resetRegistryId"
                  >
                    <base-icon name="trash" width="22" height="22"></base-icon>
                  </b-button>
                </b-button-group>
              </b-button-toolbar>
            </div>
            <div class="col-md-4">
              <base-input
                name="description"
                type="text"
                label="Descrizione"
                autocomplete="off"
                v-model="filter.byCustom.description.value"
                placeholder="Inserisci una descrizione"
              />
            </div>
          </b-row>
          <b-row>
            <div class="col-md-4">
              <base-input
                name="new_policy_number"
                type="text"
                label="Numero polizza sostituente"
                autocomplete="off"
                v-model="filter.byNewPolicyNumber"
                placeholder="Inserisci un numero polizza"
              />
            </div>
            <div class="col-md-4">
              <base-datepicker
                name="expired_at_from"
                label="Data Scadenza dal"
                v-model="filter.byInsurancePolicyExpiration.from"
              />
            </div>
            <div class="col-md-4">
              <base-datepicker
                name="expired_at_to"
                label="Data Scadenza al"
                v-model="filter.byInsurancePolicyExpiration.to"
              />
            </div>
          </b-row>
          <b-row>
            <div class="col-md-4 align-self-center actions-wrapper d-flex">
              <b-button
                class="mr-3 btn--smaller"
                type="submit"
                variant="lisaweb"
                size="sm"
                >Cerca
              </b-button>
              <b-button
                class="btn-reset btn--transparent btn--smaller"
                type="button"
                size="sm"
                @click="onClearFilter(filterName)"
                >Reset
              </b-button>
            </div>
          </b-row>
        </b-card>
      </b-form>
    </b-collapse>
    <quick-search-registry-modal
      ref="quickSearchRegistry"
      @input="handleRegistryModalInput"
    >
    </quick-search-registry-modal>
    <table-task-inheritance
      :isTableInModal="true"
      :fields="fields"
      @manualFetch="manualFetch"
      :repository="repository"
      :resource="resource"
      :filterName="filterName"
      :performedSearch="computePerformedSearch"
      :filterCount="countActiveFilters"
      :ref="tableRef"
      noActions
      noInnerWidth
      @forcedFetch="forcedFetch"
    >
    </table-task-inheritance>
  </div>
</template>

<script>
import TableTaskInheritance from "@/components/tables/TasksInheritance";
import BaseIcon from "@/components/BaseIcon";
import BaseInput from "@/components/form/BaseInput";
import BaseDatepicker from "@/components/form/BaseDatepicker";
import FormMixin from "@/mixins/FormMixin";
import { toInfoData } from "@/utils/transforms";
import CalendarEventsAndTasksMixin from "@/mixins/CalendarEventsAndTasksMixin";
import { toLocaleDate } from "@/utils/dates";
import { getDictionary } from "@/utils/dictionary";
import { mapActions, mapGetters } from "vuex";

export default {
  mixins: [CalendarEventsAndTasksMixin, FormMixin],
  name: "Notes",
  data() {
    return {
      entity_type: "policy",
      filter: this.initFilter(),
      filterName: "filterInsurancePolicyNoteInheritanceDetail",
      repository: "task",
      resource: "tasks",
      tableRef: "NoteDetailTableRef",
      taskable_id: this.resourceId,
      taskable: "insurance_policy",
      form: {
        inpt_label_registry: null,
      },
      task_type: 2,
      task_id: null,
      formLoaded: false,
      fields: [
        {
          key: "custom_actions",
          label: "",
          sortable: false,
          thStyle: {
            width: "120px",
            //width: `${20 * this.actions.length}px`,
          },
        },
        {
          key: "insurance_policies[0].number",
          label: this.getDictionary("polizza_sostituita", "task"),
          sortable: true,
          sortKey: "byInsurancePolicy.number",
        },
        {
          key: "insurance_policies[0].registry",
          label: this.getDictionary("contractor"),
          sortable: true,
          sortKey: "byInsurancePolicy.registry",
          formatter: (value) => this.toInfoData(value, "registryfullname"),
        },
        {
          key: "insurance_policies[0].expired_at",
          label: this.getDictionary("expired_at", "insurance_policy"),
          sortable: true,
          sortKey: "byInsurancePolicy.expired_at",
          formatter: (value) => toLocaleDate(value),
        },
        {
          key: "insurance_policies[0].broker_id",
          label: this.getDictionary("salesman"),
          sortable: true,
          sortKey: "byInsurancePolicy.broker_id",
          formatter: (value) => this.toBrokerInfo(value),
        },
        {
          key: "description",
          label: this.getDictionary("description", "task"),
          sortable: true,
          sortKey: "byCalendar.description",
        },
        {
          key: "insurance_policies_new_policy[0].new_policies_lite[0].number",
          label: this.getDictionary("polizza_sostituente", "task"),
          formatter: (value) => (value ? value : "-"),
          sortable: true,
          sortKey: "byInsurancePolicy.new_policy_number",
        },
        {
          key: "insurance_policies_new_policy[0].new_policies_lite[0].status_policy",
          label: this.getDictionary("status_policy", "insurance_policy"),
          sortable: true,
          sortKey: "byInsurancePolicy.new_policy_status_policy",
          formatter: (value) => (value ? value.text : "-"),
        },
        {
          key: "insurance_policies_new_policy[0].new_policies_lite[0].covered_at",
          label: this.getDictionary("covered_at", "insurance_policy"),
          sortable: true,
          sortKey: "byInsurancePolicy.new_policy_covered_at",
          formatter: (value) => (value ? toLocaleDate(value) : "-"),
        },
      ],
    };
  },
  components: {
    TableTaskInheritance,
    BaseIcon,
    BaseInput,
    BaseDatepicker,
    QuickSearchRegistryModal: () => import("@/components/modals/quickSearchRegistry"),
  },
  computed: {
    computePerformedSearch() {
      return this.performedSearch;
    },
    countActiveFilters() {
      return [
        this.filter.byInsurancePolicy.number,
        this.filter.byInsurancePolicy.registry_id,
        this.filter.byNewPolicyNumber,
        this.filter.byInsurancePolicyExpiration.from,
        this.filter.byInsurancePolicyExpiration.to,
        this.filter.byCustom.description.value,
      ].filter((value) => value !== null && value !== "").length;
    },
  },
  methods: {
    toInfoData,
    getDictionary,
    manualFetch() {
      this.onClearFilter(this.filterName);
    },
    toBrokerInfo(id) {
      if (!id) return "-";
      return this.salesmen.find((s) => s.value == id).text ?? "-";
    },
    initFilter() {
      let init = {
        byInsurancePolicy: {
          number: null,
          registry_id: null,
        },
        byNewPolicyNumber: null,
        byInsurancePolicyExpiration: {
          from: null,
          to: null,
        },
        byCustom: {
          description: {
            value: null,
            likewise: 3,
            filter: "byAttribute",
          },
        },
      };
      return init;
    },
    forcedFetch() {
      this.fetchTable();
    },
    fetchTable() {
      return this.$refs[this.tableRef].fetch().catch((error) => {
        let errMsg = this.$getErrorMessage(error);
        this.$showSnackbar({ preset: "error", text: errMsg });
      });
    },
    onSearch(name) {
      let criteria = this.filter;
      this.saveFilterByName({ name, criteria });
      this.removePaginationByName(name);
      this.$refs[this.tableRef].currentPage = 1;
      this.fetchTable();
    },
    onClearFilter(name) {
      this.filter = this.initFilter();
      this.resetRegistryId();
      this.removeFilterByName(name);
      this.removePaginationByName(name);
      this.removeSortByName(name);
      this.$refs[this.tableRef].sortBy = "";
      this.$refs[this.tableRef].sortDesc = false;
      this.onSearch(name);
    },
    openQuickSearchRegistry() {
      this.$bvModal.show("quickSearchRegistryModal");
    },
    handleRegistryModalInput(value) {
      this.filter.byInsurancePolicy.registry_id = value.id;
      this.form.inpt_label_registry = this.toInfoData(
        value,
        "registryfullname"
      );
      this.$bvModal.hide("quickSearchRegistryModal");
    },
    resetRegistryId() {
      this.filter.byInsurancePolicy.registry_id = null;
      this.form.inpt_label_registry = null;
    },
    ...mapGetters("auth", {
      getSalesmen: "salesmen",
    }),
    ...mapActions("filters", {
      saveFilterByName: "saveByName",
      removeFilterByName: "removeByName",
    }),
    ...mapActions("pagination", { removePaginationByName: "removeByName" }),
    ...mapActions("sorts", { removeSortByName: "removeByName" }),
  },
  mounted() {
    this.onSearch(this.filterName);
    this.salesmen = this.getSalesmen();
  },
};
</script>

<style>
/* Distanza tra le righe di filtri */
#manual-notes-filter .form-group {
  margin-bottom: 0.5rem;
}

/* Nel .filter-item della sidebar il .form-group ha margine zero, in modale no:
   senza questo i pulsanti, allineati in basso dal .btn-group, restano sfalsati
   rispetto all'input readonly dell'anagrafica. */
#manual-notes-filter .manual-notes-registry-picker .form-group {
  margin-bottom: 0;
}

.manual-notes-registry-picker {
  margin-bottom: 0.5rem;
}

/* Distanza tra la barra dei tab e il pulsante dei filtri */
.modal-note-manuali .modal-body .tab-content {
  padding-top: 0;
}

.manual-notes-filter-toggle {
  margin-top: -0.25rem;
  margin-bottom: 0.25rem;
}
</style>
